import { CFooter } from '@coreui/react'
import React from 'react'
import { getYear } from 'date-fns'

const AppFooter = () => {
  const currentYear = getYear(new Date())
  return (
    <CFooter>
      <div>
        iVetted Private Attestations
        <span className="ms-1">
          © {`${currentYear} `}{' '}
          <a
            href="https://www.aiopartners.com"
            className="text-blue text-decoration-none fw-normal"
          >
            Vetted IT Ltd
          </a>
        </span>
      </div>
      <div className="ms-auto">
        {/* <span className="me-1">Powered by</span>
        <a href="https://coreui.io/react" target="_blank" rel="noopener noreferrer">
          CoreUI React Admin &amp; Dashboard Template
        </a> */}
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
